import { useEffect, useState } from "react";

const navLinks = [
  { href: "#features", label: "核心能力" },
  { href: "#how", label: "使用教程" },
  { href: "#hot", label: "热门番剧" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg text-background-50 ${
              scrolled ? "bg-primary-500" : "bg-white/20"
            }`}
          >
            <i className="ri-tv-2-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl ${
              scrolled ? "text-foreground-950" : "text-white"
            }`}
          >
            小猴看番
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#how"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即体验
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden flex h-9 w-9 items-center justify-center rounded-md ${
            scrolled ? "text-foreground-950" : "text-white"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-foreground-800 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#how"
              onClick={() => setOpen(false)}
              className="rounded-md bg-primary-500 px-4 py-2 text-center text-sm font-medium text-background-50"
            >
              立即体验
            </a>
          </div>
        </div>
      )}
    </header>
  );
}